const appBarTemplateId = '11.1.3';

export interface AppBarElmIds {
  root: string;
  logoButton: string;
  userButton: string;
  mobileMenuButton: string;
  cartButton: string;
  o2CzButton: string;
  o2Id: string;
  userButtonTooltip: string;
}

const elmIds: AppBarElmIds = {
  root: appBarTemplateId,
  logoButton: `${appBarTemplateId}_002`,
  userButton: `${appBarTemplateId}_003`,
  mobileMenuButton: `${appBarTemplateId}_004`,
  cartButton: `${appBarTemplateId}_009`,
  o2CzButton: `${appBarTemplateId}_010`,
  o2Id: `${appBarTemplateId}_026`,
  userButtonTooltip: `${appBarTemplateId}_029`,
};

export default elmIds;
